var map = {
	"./de-DE/plugin-tags": 3824,
	"./en-US/plugin-tags": 86299,
	"./es-ES/plugin-tags": 27930,
	"./fa-IR/plugin-tags": 3154,
	"./fr-FR/plugin-tags": 77230,
	"./hi-IN/plugin-tags": 59568,
	"./it-IT/plugin-tags": 36776,
	"./ja-JP/plugin-tags": 6731,
	"./ko-KR/plugin-tags": 63709,
	"./pl-PL/plugin-tags": 24954,
	"./pt-BR/plugin-tags": 90450,
	"./ro-RO/plugin-tags": 97096,
	"./ru-RU/plugin-tags": 77684,
	"./sl-SI/plugin-tags": 74435,
	"./th-TH/plugin-tags": 50146,
	"./tr-TR/plugin-tags": 35970,
	"./uk-UA/plugin-tags": 27992,
	"./vi-VN/plugin-tags": 86041,
	"./zh-Hans/plugin-tags": 57652,
	"./zh-Hant/plugin-tags": 83321
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59018;